import React from 'react';

// UI
import {
  Box,
  Stack,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material';

import {
  Search as SearchIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
} from '@mui/icons-material';
import { ReactComponent as ViewModeListIcon } from 'assets/icons/project/table.svg';
import { ReactComponent as ViewModeUserIcon } from 'assets/icons/project/account.svg';
// Redux & Sagas
import { useSelector } from 'react-redux';
import { selectMember } from '../slice/selectors';

// Library
import { useForm, Controller } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import Path from 'config/clientPath';
interface IFilterBarProps {
  currentMemberTab: string | null;
  handleChangeMemberTab: any;
}

export function FilterBar(props: IFilterBarProps) {
  const { handleSubmit, register, reset, control, watch } = useForm();
  const { currentMemberTab, handleChangeMemberTab } = props;
  const { project_role_metadata } = useSelector(selectMember);

  const searchForm = React.useRef<HTMLFormElement>();
  const history = useHistory();

  const handSearch = _formData => {
    const params = new URLSearchParams(window.location.search);
    const formData = params.get('page') ? { ..._formData, page: 1 } : _formData;
    let qs = Object.keys(formData)
      .map(key => (formData[key] ? key + '=' + formData[key] : ''))
      .filter(o => o)
      .join('&');
    history.push(`${Path.MEMBERS}?${qs}`);
  };

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    reset({
      role: params.get('role') || '',
      status: params.get('status') || '',
      search: params.get('search') || '',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name === 'role' || name === 'status') {
        requestSubmit();
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const requestSubmit = () => {
    setTimeout(() => searchForm.current?.requestSubmit(), 10);
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      component="form"
      method="GET"
      ref={searchForm}
      onSubmit={handleSubmit(handSearch)}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <InputLabel>Role: </InputLabel>

        <FormControl>
          <Controller
            control={control}
            name="role"
            render={({ field }) => {
              const { onBlur, onChange, value } = field;
              return (
                <Select
                  fullWidth
                  displayEmpty
                  size="small"
                  variant="standard"
                  onBlur={onBlur}
                  onChange={onChange}
                  value={`${value}`}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  <MenuItem value="">All</MenuItem>
                  {project_role_metadata?.map(it => (
                    <MenuItem key={`m_f_${it.id}`} value={it.id}>
                      {it.name}
                    </MenuItem>
                  ))}
                </Select>
              );
            }}
          />
        </FormControl>

        <InputLabel>Status: </InputLabel>
        <FormControl>
          <Controller
            control={control}
            name="status"
            render={({ field }) => {
              const { onBlur, onChange, value } = field;
              return (
                <Select
                  fullWidth
                  displayEmpty
                  size="small"
                  variant="standard"
                  onBlur={onBlur}
                  onChange={onChange}
                  value={`${value}`}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  <MenuItem value={''}>All</MenuItem>
                  <MenuItem value="1">Active</MenuItem>
                  <MenuItem value="2">Deactive</MenuItem>
                </Select>
              );
            }}
          />
        </FormControl>
      </Stack>

      <Stack direction="row" spacing={2} alignItems="center">
        <InputLabel>View mode:</InputLabel>
        <ToggleButtonGroup
          value={currentMemberTab}
          exclusive
          onChange={handleChangeMemberTab}
        >
          <ToggleButton value="LIST_TAB" aria-label="table">
            <ViewModeListIcon />
          </ToggleButton>
          <ToggleButton value="INVITE_TAB" aria-label="account">
            <ViewModeUserIcon />
          </ToggleButton>
        </ToggleButtonGroup>
        <TextField
          type="search"
          placeholder="Name"
          aria-label="Search"
          size="small"
          sx={{
            background: '#fff',
          }}
          onKeyUp={event => {
            if (event.key === 'Enter') {
              requestSubmit();
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          {...register('search')}
        />
      </Stack>
    </Box>
  );
}

export default FilterBar;
